import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative w-full bg-background-200/50 border-t border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
              Sugargoo Spreadsheet
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              The ultimate resource hub for Sugargoo Spreadsheet collections, product guides, 
              reviews, shipping information, and expert shopping tips. Helping international shoppers 
              discover and purchase products through Sugargoo with confidence.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Categories</a>
              </li>
              <li>
                <a href="/#about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">About</a>
              </li>
              <li>
                <a href="/#guides" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Guides</a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Main Website</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Sugargoo Spreadsheet</a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Buy It Now</a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">All Products</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} sugargoospread.link. All rights reserved. This site is an independent resource and is not affiliated with Sugargoo.
          </p>
          <div className="flex items-center gap-6">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}